import React from 'react';
import {Outlet, Route, Routes} from "react-router-dom";
import NavLayout from "../../../_components/layouts/nav/NavLayout";
import SubscriptionsPage from "./subscriptions/SubscriptionsPage";

function SubscriptionsRoutes() {
    return (
        <Routes>
            <Route element={<NavLayout> <Outlet /> </NavLayout>}>
                <Route path={'/'} element={ <SubscriptionsPage />} />
            </Route>
        </Routes>
    );
}

export default SubscriptionsRoutes;